import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HomeIcon, CartIcon, ProfileIcon } from "../GetIcons";
import { useItemContext } from "../../contexts/ItemContext";
import { useFavs } from "../../contexts/FavsProvider";
import { useTelegram } from "../../hooks/useTelegram";
import "./BottomMenu.scss";

const BottomMenu = () => {
  const { cartItems } = useItemContext();
  const { triggerHapticFeedback } = useTelegram();
  const { setFavs } = useFavs();
  const location = useLocation();

  const [animateCart, setAnimateCart] = useState(false); // Animation state
  const [displayedTotalSum, setDisplayedTotalSum] = useState(0); // For delayed number display

  /**
   * Determine if the given path is the current active route.
   * @param {string} path - The path to check against the current location.
   * @returns {boolean} True if active, false otherwise.
   */
  const isActive = (path) => location.pathname === path;

  /**
   * Handle click on a navigation link.
   * Triggers haptic feedback and resets favorites state if needed.
   * @param {string} path
   */
  const handleLinkClick = (path) => {
    triggerHapticFeedback("impact", "medium");
    setFavs(0);
  };

  // Calculate total quantity
  const totalSum = cartItems.reduce((acc, item) => acc + item.quantity, 0);

  // Trigger animation and delay number update
  useEffect(() => {
    if (cartItems.length > 0) {
      setAnimateCart(true); // Start animation
      const animationTimeout = setTimeout(() => {
        setAnimateCart(false); // End animation
        setDisplayedTotalSum(totalSum); // Update displayed total
      }, 400); // Animation duration

      return () => clearTimeout(animationTimeout);
    } else {
      setDisplayedTotalSum(0); // Reset to 0 if no items in the cart
    }
  }, [cartItems, totalSum]); // Run effect when cartItems changes

  return (
    <nav className="menu">
      <Link
        to="/home"
        className={`link ${isActive("/home") ? "active" : ""}`}
        onClick={() => handleLinkClick("/home")}
      >
        <HomeIcon fillColor={isActive("/home") ? "#FFFFFF80" : "#FFFFFF"} />
        <span className="linkText">Каталог</span>
      </Link>

      <Link
        to="/cart"
        className={`link ${isActive("/cart") ? "active" : ""}`}
        onClick={() => handleLinkClick("/cart")}
      >
        <div className={animateCart ? "animate" : ""}>
          <CartIcon fillColor={isActive("/cart") ? "#FFFFFF80" : "#FFFFFF"} />
        </div>
        <span className="linkText">Корзина</span>
        {cartItems.length > 0 && (
          <span className={`cartCount ${animateCart ? "animate" : ""}`}>{displayedTotalSum}</span>
        )}
      </Link>

      <Link
        to="/profile"
        className={`link ${isActive("/profile") ? "active" : ""}`}
        onClick={() => handleLinkClick("/profile")}
      >
        <ProfileIcon fillColor={isActive("/profile") ? "#FFFFFF80" : "#FFFFFF"} />
        <span className="linkText">Профиль</span>
      </Link>
    </nav>
  );
};

export default BottomMenu;
